import customAxios from '@Utils/Axios';

const postProjectEvent = async data => {
  await customAxios.post('/project_event', { ...data });
};

const getProjectEvent = async projectId => {
  const response = await customAxios.get(`/project_event?projectId=${projectId}`);

  return response;
};

export { postProjectEvent, getProjectEvent };
